export enum INVOICE_PAYMENT_STATUS {
  CUSTOMER_DRAFT,
  STAFF_DRAFT,
  PENDING,
  PAID,
}

export const invoicePaymentStatusLabels = {
  [INVOICE_PAYMENT_STATUS.CUSTOMER_DRAFT]: 'Draft',
  [INVOICE_PAYMENT_STATUS.STAFF_DRAFT]: 'Draft',
  [INVOICE_PAYMENT_STATUS.PENDING]: 'Pending',
  [INVOICE_PAYMENT_STATUS.PAID]: 'Paid',
};

export const invoicePaymentStatusColorMap = {
  [INVOICE_PAYMENT_STATUS.CUSTOMER_DRAFT]: ['#FFF200', 'black'],
  [INVOICE_PAYMENT_STATUS.STAFF_DRAFT]: ['#FFF200', 'black'],
  [INVOICE_PAYMENT_STATUS.PENDING]: ['#D400FF', 'white'],
  [INVOICE_PAYMENT_STATUS.PAID]: ['#00D624', 'white'],
};
